import { useEffect, useState } from 'react';
import { routesLists } from 'routes/route-lists';
import AppRoutes from 'routes/routes';

import { useDecodeToken } from 'hooks/useStorage';
import { userRoutesLists } from 'routes/user-route-list';
import './App.css';
import ConfigurationContextProvider from 'components/provider/OrginazationContext';
import FallBackLoader from 'components/ui/FallBackLoader';

function App() {
  // Show a loader on the very first render so we never flash the wrong route
  // before the token has been read from localStorage.
  const [authChecking, setAuthChecking] = useState(true);
  const decodedToken = useDecodeToken();

  useEffect(() => {
    setAuthChecking(false);
  }, []);

  if (authChecking) {
    return <FallBackLoader />;
  }

  return (
    <ConfigurationContextProvider>
      <AppRoutes
        routes={
          decodedToken?.Role === 'Admin' && decodedToken?.UserType == 1
            ? routesLists
            : userRoutesLists
        }
      />
    </ConfigurationContextProvider>
  );
}

export default App;
